module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.63fdd1d0.webp";